var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridInstagramFeed',{key:_vm.renderKey,attrs:{"media":_vm.media},on:{"dragstart":function($event){$event.stopPropagation();$event.preventDefault();}}})}
var staticRenderFns = []

export { render, staticRenderFns }